import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-financeiro-modal-recebimento',
  templateUrl: './financeiro-modal-recebimento.component.html',
  styleUrls: ['./financeiro-modal-recebimento.component.css'],
  standalone: false
})
export class FinanceiroModalRecebimentoComponent {
  @Input() recebimento: any;
  @Output() fechar = new EventEmitter<void>();
  @Output() confirmar = new EventEmitter<void>();

  fecharModal() {
    this.fechar.emit();
  }

  confirmarRecebimento() {
    this.confirmar.emit();
  }
}
